(() => {
  if (window.__velvetMobileExperienceReady) return;
  window.__velvetMobileExperienceReady = true;

  const phone = window.matchMedia('(max-width: 749px)');
  const bars = new Set();
  let frame = 0;

  const updateBars = () => {
    frame = 0;
    bars.forEach(({ bar, button }) => {
      if (!bar.isConnected || !button?.isConnected) return;
      const buttonBox = button.getBoundingClientRect();
      const show = phone.matches && buttonBox.bottom < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
    });
  };

  const requestUpdate = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(updateBars);
  };

  const initialise = scope => {
    scope.querySelectorAll?.('[data-vc-mobile-buy-bar]').forEach(bar => {
      if (bar.dataset.vcMobileVisibilityReady === 'true') return;
      bar.dataset.vcMobileVisibilityReady = 'true';
      const mobileButton = bar.querySelector('[data-vc-mobile-add]');
      const button = mobileButton?.dataset.mainSubmit
        ? document.getElementById(mobileButton.dataset.mainSubmit)
        : null;
      if (!button) return;
      bars.add({ bar, button });
    });
    requestUpdate();
  };

  document.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  phone.addEventListener?.('change', requestUpdate);
  document.addEventListener('shopify:section:load', event => initialise(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document));
  } else {
    initialise(document);
  }
})();
